/**
 * Ce que la page du classement et son squelette partagent : la largeur à partir de laquelle les
 * classements se posent côte à côte, et la feuille qui les pose. La page et son squelette lisent
 * LA MÊME, pour que les listes tombent là où le squelette les annonçait.
 */
import { StyleSheet } from "react-native-unistyles"

/** En dessous, un classement à la fois, choisi par ses pilules ; au-dessus, tous côte à côte. */
export const RANKING_SIDE_BY_SIDE_FROM = 720

/** Un classement seul au large : une ligne plus longue ne se lit plus d'un rang à son XP. */
const RANKING_SINGLE_MAX_WIDTH = 640

export const rankingLayoutStyles = StyleSheet.create((theme) => ({
    /** La largeur de la colonne appartient à la page (`PageTemplate maxContentWidth`). */
    fullWidth: { width: "100%" },
    boards: { flexDirection: "row", alignItems: "flex-start", gap: theme.spacing["4"] },
    board: { flex: 1, minWidth: 0 },
    single: { width: "100%", maxWidth: RANKING_SINGLE_MAX_WIDTH, alignSelf: "center" },
    pills: { flexDirection: "row", gap: theme.spacing["2"] },
    pill: { flex: 1, minWidth: 0 },
}))
